import { render, staticRenderFns } from "./KpiStarItem.vue?vue&type=template&id=75614ffc&scoped=true&slot=header&"
import script from "./KpiStarItem.vue?vue&type=script&lang=js&"
export * from "./KpiStarItem.vue?vue&type=script&lang=js&"
import style0 from "./KpiStarItem.vue?vue&type=style&index=0&id=75614ffc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75614ffc",
  null
  
)

export default component.exports